import React from 'react';
import { Link } from 'react-router-dom';
import Facebook from 'lucide-react/dist/esm/icons/facebook';
import Instagram from 'lucide-react/dist/esm/icons/instagram';
import Youtube from 'lucide-react/dist/esm/icons/youtube';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content container">
        <div className="footer-logo">
          <h2 className="anton-font">STILLAUT</h2>
        </div>

        <div className="footer-grid">
          <div className="footer-section">
            <h3 className="footer-title">Company</h3>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/size-guide">Size Guide</Link></li>
              <li><Link to="/shipping">Shipping & Returns</Link></li>
              <li><Link to="/news">News</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Catalog</h3>
            <ul className="footer-links">
              <li><Link to="/?category=tops">Tops</Link></li>
              <li><Link to="/?category=outerwear">Outerwear</Link></li>
              <li><Link to="/?category=caps">Caps</Link></li>
              <li><Link to="/?category=accessories">Accessories</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Terms & Policy</h3>
            <ul className="footer-links">
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/cookies">Cookie Policy</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contact</h3>
            <ul className="footer-links">
              <li><a href="mailto:support@stillaut.com">support@stillaut.com</a></li>
              <li><a href="tel:+11234567890">+1 (123) 456-7890</a></li>
              <li><Link to="/stores">Store Locations</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-social">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <Facebook size={20} />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <Instagram size={20} />
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <Youtube size={20} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
